<template>
  <div class="bgs">
    <div class="bgs__header filters-bar">
      <i-button
        v-if="getCommonModulePerms('bank_guarantee', 'create')"
        type="success"
        @click="handleEdit(null)"
      >
        Создать БГ
      </i-button>
    </div>

    <inline-loader :loading="loading" v-if="loading && !nodata" />
    <div class="ms-nodata ms-text" v-else-if="!loading && nodata">
      Не удалось загрузить список БГ. Повторите, пожалуйста, попытку позже
    </div>
    <bgs-list v-else-if="bgs.length" :bgs="bgs" @edit="handleEdit" />
    <div v-else class="ms-nodata ms-text">Банковские гарантии отсутствуют</div>

    <modal
      v-model="editorModal"
      :styles="{ top: '40px' }"
      width="720"
      :mask-closable="false"
      :before-close="closeModal"
    >
      <div slot="header" class="bgs-editor-header">
        <icon size="16" type="md-create" class="ms-help" />
        <span style="margin-left: 4px" class="ms-help">
          {{ editingBg.id || !!sourceLoading ? "Редактирование" : "Создание" }}
          БГ
        </span>
      </div>

      <div class="bgs-editor-versions" v-if="versions && versions.length > 1">
        <span class="ms-help label">Версия</span>
        <i-select v-model="currentVersion" @on-change="changeVersion">
          <i-option
            v-for="item in versions"
            :value="item.id"
            :key="item.id"
            :label="item.name"
          >
            {{ item.name }}
          </i-option>
        </i-select>
      </div>

      <inline-loader v-if="sourceLoading" :loading="sourceLoading" />
      <bgs-editor
        v-else
        :source="editingBg"
        :is-save-available="isSaveAvailable"
      />

      <div slot="footer" class="bgs-editor-footer">
        <i-button
          v-if="editingBg.id"
          size="default"
          type="error"
          @click="deleteModal = true"
        >
          Удалить
        </i-button>

        <div class="bgs-editor-footer__save">
          <i-button
            v-if="editingBg.id"
            size="default"
            :disabled="!isSaveAvailable"
            type="primary"
            @click="handleSave('version')"
            :loading="saving"
          >
            Сохранить новую версию
          </i-button>

          <i-button
            size="default"
            :disabled="!isSaveAvailable"
            type="success"
            @click="handleSave"
            :loading="saving"
          >
            Сохранить
          </i-button>
        </div>
      </div>
    </modal>

    <modal :z-index="2000" v-model="deleteModal" width="360">
      <p slot="header" style="color: #f60; text-align: center">
        <icon type="ios-information-circle" />
        <span style="margin-left: 4px">Удаление данных</span>
      </p>
      <div style="text-align: center">
        <p class="ms-text">Данное действие невозможно отменить. Вы уверены?</p>
      </div>
      <div slot="footer">
        <div v-if="!!versions" class="bgs-editor-delete">
          <i-button
            v-if="versions.length > 1"
            type="error"
            size="default"
            long
            :loading="deleteLoading"
            :disabled="deleteLoading"
            @click="deleteVersion"
          >
            Удалить эту версию
          </i-button>
          <i-button
            v-else
            type="error"
            size="default"
            long
            :loading="deleteLoading"
            :disabled="deleteLoading"
            @click="deleteBg"
          >
            Полностью удалить БГ
          </i-button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import cloneDeep from 'lodash.clonedeep'
import moment from 'moment'
import { bg } from '@/config/bgs'
import { formatDefaultDate, parseDateToServer, isValidEmail } from '@/utils'
import InlineLoader from '@/components/loaders/inline-loader'
import BgsList from '@/components/bgs/bgs-list'
import BgsEditor from '@/components/bgs/bgs-editor'

export default {
  components: {
    InlineLoader,
    BgsList,
    BgsEditor
  },
  data () {
    return {
      loading: false,
      nodata: false,
      bgs: [],
      sourceLoading: false,
      currentId: null,
      editingBg: cloneDeep(bg),
      editorModal: false,
      saving: false,
      deleteLoading: false,
      deleteModal: false,
      versions: null,
      currentVersion: null
    }
  },
  computed: {
    isSaveAvailable () {
      const {
        amount,
        start_date,
        end_date,
        bg_type_id,
        contact_fio,
        contact_phone,
        contact_email
      } = this.editingBg

      return (
        amount &&
        bg_type_id &&
        start_date &&
        end_date &&
        contact_fio &&
        contact_phone &&
        contact_email
      )
    }
  },
  methods: {
    async getSources () {
      try {
        const bgsTypes = await this.$store.dispatch('GET_REQUEST', {
          url: 'objectInfo/bg_types'
        })
        this.$store.commit('SET_CONTRACTS_FIELD', ['bgsTypes', bgsTypes])

        const banks = await this.$store.dispatch('GET_REQUEST', {
          url: 'objectInfo/banks'
        })
        this.$store.commit('SET_CONTRACTS_FIELD', ['banks', banks])
      } catch (error) {
        console.log(error)
      }
    },
    async getBgs (noloading) {
      const { id } = this.$route.params

      try {
        if (!noloading) this.loading = true

        const url = `page/bg?contract_id=${id}`

        this.bgs = await this.$store.dispatch('GET_REQUEST', { url })
        this.loading = false
      } catch (error) {
        console.log(error)
        this.loading = false
        this.nodata = true
      }
    },
    async handleEdit (source) {
      this.$set(this, 'versions', null)
      this.$set(this, 'currentVersion', null)

      if (source && source.id) {
        this.currentId = source.id
        this.getSourceData()
      } else {
        this.editingBg = cloneDeep(bg)
      }

      this.editorModal = true
    },
    parseDataFromServer (data) {
      const result = cloneDeep(data)

      if (result.start_date) {
        result.start_date = formatDefaultDate(result.start_date)
      }
      if (result.end_date) {
        result.end_date = formatDefaultDate(result.end_date)
      }

      return result
    },
    async getSourceData () {
      try {
        this.sourceLoading = true

        const url = `page/bg/${this.currentId}`
        const bg = await this.$store.dispatch('GET_REQUEST', { url })

        const versions = bg.versions.map((v, i) => ({
          ...v,
          name: `Версия ${i + 1} (последнее изменение: ${moment(
            v.updated_at
          ).format('DD.MM.YYYY HH:mm')})`
        }))

        this.$set(
          this,
          'editingBg',
          this.parseDataFromServer(versions[versions.length - 1])
        )
        this.$set(this, 'versions', versions)
        this.$set(this, 'currentVersion', this.editingBg.id)
      } catch (error) {
        console.log(error)
      } finally {
        this.sourceLoading = false
      }
    },
    changeVersion (id) {
      const data = cloneDeep(this.versions.find(v => v.id === id))
      const parsedData = this.parseDataFromServer(data)

      if (data) {
        this.$set(this, 'editingBg', parsedData)
      }
    },
    getEditingData (type) {
      const { start_date, end_date } = this.editingBg
      const data = {
        ...this.editingBg,
        start_date: parseDateToServer(start_date),
        end_date: parseDateToServer(end_date),
        contract_id: this.$route.params.id
      }

      delete data.name
      delete data.tracking_number

      if (type === 'version') {
        delete data.id
        delete data.object_resources
      }

      return data
    },
    getUrl (type) {
      switch (type) {
        case 'version':
          return `page/bg?create_new_version=`
        default: {
          if (this.editingBg.id) {
            return `page/bg?update_version=`
          } else {
            return `page/bg?create_new_bg=`
          }
        }
      }
    },
    async handleSave (type = 'default') {
      const { contact_email } = this.editingBg

      if (contact_email && !isValidEmail(contact_email)) {
        this.$Message.error('Введите корректный адрес электронной почты')

        return
      }

      try {
        this.saving = true

        const url = this.getUrl(type)
        const data = this.getEditingData(type)

        await this.$store.dispatch('POST_REQUEST', { url, data })
        await this.getBgs()

        this.$Message.success('Сохранение данных выполнено успешно')

        this.saving = false

        if (type === 'version') {
          this.getSourceData()
        } else {
          this.closeModal()
        }
      } catch (error) {
        console.log(error)
        this.$Message.error('Произошла ошибка при сохранении данных')
        this.saving = false
      }
    },
    async deleteVersion () {
      try {
        this.deleteLoading = true

        const url = `page/bg?update_version=`
        const data = {
          id: this.editingBg.id,
          bg_id: this.editingBg.bg_id,
          disabled: true
        }

        await this.$store.dispatch('POST_REQUEST', { url, data })

        this.$Message.success('Удаление данных выполнено успешно')
        this.getSourceData()

        this.deleteModal = false
      } catch (error) {
        console.log(error)
        this.$Message.error('Произошла ошибка при удалении данных')
      } finally {
        this.deleteLoading = false
      }
    },
    async deleteBg () {
      if (!this.currentId) return

      try {
        this.deleteLoading = true
        const url = `page/bg?id=${this.currentId}`
        await this.$store.dispatch('DELETE_REQUEST', { url })
        await this.getBgs()

        this.$Message.success('Удаление данных выполнено успешно')

        this.closeModal()
      } catch (error) {
        console.log(error)
        this.$Message.error('Произошла ошибка при удалении данных')
      } finally {
        this.deleteLoading = false
      }
    },
    closeModal () {
      this.editorModal = false
      this.deleteModal = false
      this.currentId = null
      this.$set(this, 'versions', null)
      this.currentVersion = null
    }
  },
  created () {
    this.getSources()
    this.getBgs()
  }
}
</script>

<style lang="less">
.bgs {
  &__header {
    justify-content: flex-end;
  }

  &-editor-versions {
    margin-bottom: 16px;
  }

  &-editor-footer {
    display: flex;

    &__save {
      margin-left: auto;
    }
  }

  &-editor-delete {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }
}
</style>
